export enum SliderTypes {
  SET_SLIDER_DATA = 'SET_SLIDER_DATA',
}

